import React from "react"

const BarItem = props => <div className="layout-rt__bar-item">{props.children}</div>

export default BarItem
